import { inject, Injectable } from '@angular/core';
import { DocumentEntity, DocumentTypeEnum } from '@domain';
import { RaToastService } from '@shared/components';
import { catchError, map, Observable } from 'rxjs';
import { UtilService } from 'src/app/shared/utils/utils.service';
import { DocumentCreateApi } from '../../APIs/documents/document-create.api';
import { DomainTranslateService } from '../../utils/domain-translate.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentCreateController {
    // * [API]
    private _api = inject(DocumentCreateApi);

    // * [Injects]
    private _utilService = inject(UtilService);
    private _raToastService = inject(RaToastService);
    private _i18n = inject(DomainTranslateService);

    public insertBlankDocument(
        orderId: string,
        type: DocumentTypeEnum = DocumentTypeEnum.NORMAL
    ): Observable<DocumentEntity> {
        return this._api.insert(orderId, type).pipe(
            map(response => {
                // Mensagem de sucesso
                this._raToastService.success({
                    message: response.message[0] || this._i18n.instant('domain.document.success.created'),
                });

                return response.body;
            }),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.createDocument')
                )
            )
        );
    }

    /**
     * Cria um documento AVULSO (sem serviço/cliente) — a order pessoal
     * invisível é criada pelo backend. Usado pelo feed unificado.
     */
    public insertStandalone(
        type: DocumentTypeEnum = DocumentTypeEnum.NORMAL
    ): Observable<DocumentEntity> {
        return this._api.insertStandalone(type).pipe(
            map(response => {
                // Mensagem de sucesso
                this._raToastService.success({
                    message: response.message[0] || this._i18n.instant('domain.document.success.created'),
                });

                return response.body;
            }),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.createDocument')
                )
            )
        );
    }

    public insertByTemplate(orderId: string | null, templateId: string): Observable<DocumentEntity> {
        return this._api.insertByTemplate(orderId, templateId).pipe(
            map(response => {
                // Mensagem de sucesso
                this._raToastService.success({
                    message: response.message[0] || this._i18n.instant('domain.document.success.created'),
                });

                return response.body;
            }),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.createDocument')
                )
            )
        );
    }

    public insertByInternalTemplate(
        orderId: string | null,
        internalTemplateId: string
    ): Observable<DocumentEntity> {
        return this._api.insertByInternalTemplate(orderId, internalTemplateId).pipe(
            map(response => {
                // Mensagem de sucesso
                this._raToastService.success({
                    message: response.message[0] || this._i18n.instant('domain.document.success.created'),
                });

                return response.body;
            }),
            catchError(error =>
                this._utilService.handleError(
                    error,
                    this._i18n.instant('domain.document.errors.createDocument')
                )
            )
        );
    }
}
